import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CustomCard from "../../CustomCard";

import BCard from "../../../../assets/images/BusinessSection/BusinessCard.jpg";
import Letter from "../../../../assets/images/BusinessSection/LetterHead.jpg";
import Invoice from "../../../../assets/images/BusinessSection/Invoice.png";
import HomeSection4 from "./Section4";
import HomeSection5 from "./Section5";
import HomeSection7 from "./Section7";
import Office from "../Office";

// Card Data
const cardData = [
  { image: BCard, text: "Business Cards" },
  { image: Letter, text: "Letter Heads" },
  { image: Invoice, text: "Invoice Books" },
];

function HomeSection6() {
  return (
    <>
      <Container className="mt-4 w-100 p-0">
        <h2 className="py-4 fw-bold text-center">Business Section</h2>

        {/* 1st row */}
        <Row>
          {cardData.map((card, index) => (
            <Col md={4} className="d-flex">
              <CustomCard key={index} image={card.image} text={card.text} />
            </Col>
          ))}
        </Row>

        {/* 2nd row */}
        {/* Digital Printing */}

        <div id="section-6-d">
          <HomeSection5 />
        </div>

        {/* 2nd row */}

        <div id="section-6-boards">
          <HomeSection7 />
        </div>

        {/* 3rd row */}
        {/* Flex Printing */}
        <div id="section-6-flex">
          <HomeSection4 />
        </div>

        {/* 4th row */}
        {/* Office Stationary */}
        <div id="section-6-office">
          <Office />
        </div>

        {/* Divider-line */}
        <hr className="divider-line" style={{ margin: "0 auto" }} />
      </Container>
    </>
  );
}

export default HomeSection6;
